import React, { useEffect, useRef, useState } from "react";
import CalendarEvent from "../../components/CalendarEvent";
import UpcomingEvent from "./UpcomingEvent";
import Gradpic from "../../image/cap-and-gown.jpg";
import NewsCard from "../../components/NewsCard";
import { news } from "../../Data";
import Carousel from "react-multi-carousel";
// import "react-multi-carousel/lib/styles.css";
import IndicatorIcon from "../../components/IndicatorIcon";
import {
  useDeviceIsLaptopSmToMobile,
  useDeviceIsMobile,
  usePagination,
} from "../../Utils";
import PaginationControls from "../../components/PaginationControls";

function NewsEvent() {
  const isMobile = useDeviceIsMobile();
  const itemsPerPage = isMobile ? 3 : news.length;

  const {
    currentIndex,
    currentSlide,
    currentItems,
    totalItems,
    handlePrevious,
    handleNext,
    setCurrentPage,
  } = usePagination(news, itemsPerPage);

  return (
    <>
      {" "}
      <div className=" responsive-padding py-10 h-auto w-full bg-secondary-lightActive ">
        <div className="w-full flex md:flex-row flex-col gap-x-4 gap-y-8">
          <div className="md:w-1/2 w-full ">
            <h2 className="font-bold font-montserrat laptopSm:text-3xl md:text-2xl text-base text-text-normal">
              News & Events
            </h2>
            {/* News Card */}
            <div className="md:overflow-x-auto laptop:h-[475px] md:h-[350px] h-auto  mt-4 w-full newsScroll md:max-h-none max-h-[369px]">
              {currentItems.length > 0 ? (
                currentItems.map((newsItem) => (
                  <NewsCard key={newsItem.id} newsItem={newsItem} />
                ))
              ) : (
                <div className=" text-gray-500 p-4">
                  No news available at the moment. Check back later for updates!
                </div>
              )}

              {/*mobile Responsive for news next page */}
              <div className="sm:w-1/2 w-3/4 md:hidden mt-6 m-auto ">
                {" "}
                <PaginationControls
                  currentIndex={currentIndex}
                  currentSlide={currentSlide}
                  totalItems={totalItems}
                  handlePrevious={handlePrevious}
                  handleNext={handleNext}
                  setCurrentPage={setCurrentPage}
                  itemsPerPage={itemsPerPage}
                  itemsLength={news.length}
                />
              </div>
            </div>
          </div>

          {/* event */}
          <div className="md:w-1/2 md:ml-4 w-full ">
            {/* calendar */}
            <div className="w-full laptop:h-[328px]   h-[250px] bg-secondary-light rounded-2xl laptop:px-10 px-4 latop:py-6 py-4">
              <div className="flex md:gap-10 gap-2 items-center text-text-normal">
                <svg
                  className="fill-text-normal w-5 h-5"
                  viewBox="0 0 18 20"
                  // fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.30775 19.5C1.80258 19.5 1.375 19.325 1.025 18.975C0.675 18.625 0.5 18.1974 0.5 17.6923V4.30777C0.5 3.8026 0.675 3.37502 1.025 3.02502C1.375 2.67502 1.80258 2.50002 2.30775 2.50002H3.69225V0.384766H5.23075V2.50002H12.8077V0.384766H14.3077V2.50002H15.6923C16.1974 2.50002 16.625 2.67502 16.975 3.02502C17.325 3.37502 17.5 3.8026 17.5 4.30777V17.6923C17.5 18.1974 17.325 18.625 16.975 18.975C16.625 19.325 16.1974 19.5 15.6923 19.5H2.30775ZM2.30775 18H15.6923C15.7692 18 15.8398 17.9679 15.9038 17.9038C15.9679 17.8398 16 17.7693 16 17.6923V8.30777H2V17.6923C2 17.7693 2.03208 17.8398 2.09625 17.9038C2.16025 17.9679 2.23075 18 2.30775 18ZM2 6.80777H16V4.30777C16 4.23077 15.9679 4.16026 15.9038 4.09626C15.8398 4.0321 15.7692 4.00002 15.6923 4.00002H2.30775C2.23075 4.00002 2.16025 4.0321 2.09625 4.09626C2.03208 4.16026 2 4.23077 2 4.30777V6.80777ZM9 12.077C8.75517 12.077 8.5465 11.9908 8.374 11.8183C8.20167 11.6459 8.1155 11.4373 8.1155 11.1923C8.1155 10.9474 8.20167 10.7388 8.374 10.5663C8.5465 10.3939 8.75517 10.3078 9 10.3078C9.24483 10.3078 9.4535 10.3939 9.626 10.5663C9.79833 10.7388 9.8845 10.9474 9.8845 11.1923C9.8845 11.4373 9.79833 11.6459 9.626 11.8183C9.4535 11.9908 9.24483 12.077 9 12.077ZM5 12.077C4.75517 12.077 4.5465 11.9908 4.374 11.8183C4.20167 11.6459 4.1155 11.4373 4.1155 11.1923C4.1155 10.9474 4.20167 10.7388 4.374 10.5663C4.5465 10.3939 4.75517 10.3078 5 10.3078C5.24483 10.3078 5.4535 10.3939 5.626 10.5663C5.79833 10.7388 5.8845 10.9474 5.8845 11.1923C5.8845 11.4373 5.79833 11.6459 5.626 11.8183C5.4535 11.9908 5.24483 12.077 5 12.077ZM13 12.077C12.7552 12.077 12.5465 11.9908 12.374 11.8183C12.2017 11.6459 12.1155 11.4373 12.1155 11.1923C12.1155 10.9474 12.2017 10.7388 12.374 10.5663C12.5465 10.3939 12.7552 10.3078 13 10.3078C13.2448 10.3078 13.4535 10.3939 13.626 10.5663C13.7983 10.7388 13.8845 10.9474 13.8845 11.1923C13.8845 11.4373 13.7983 11.6459 13.626 11.8183C13.4535 11.9908 13.2448 12.077 13 12.077ZM9 16C8.75517 16 8.5465 15.9138 8.374 15.7413C8.20167 15.5689 8.1155 15.3603 8.1155 15.1155C8.1155 14.8705 8.20167 14.6618 8.374 14.4895C8.5465 14.317 8.75517 14.2308 9 14.2308C9.24483 14.2308 9.4535 14.317 9.626 14.4895C9.79833 14.6618 9.8845 14.8705 9.8845 15.1155C9.8845 15.3603 9.79833 15.5689 9.626 15.7413C9.4535 15.9138 9.24483 16 9 16ZM5 16C4.75517 16 4.5465 15.9138 4.374 15.7413C4.20167 15.5689 4.1155 15.3603 4.1155 15.1155C4.1155 14.8705 4.20167 14.6618 4.374 14.4895C4.5465 14.317 4.75517 14.2308 5 14.2308C5.24483 14.2308 5.4535 14.317 5.626 14.4895C5.79833 14.6618 5.8845 14.8705 5.8845 15.1155C5.8845 15.3603 5.79833 15.5689 5.626 15.7413C5.4535 15.9138 5.24483 16 5 16ZM13 16C12.7552 16 12.5465 15.9138 12.374 15.7413C12.2017 15.5689 12.1155 15.3603 12.1155 15.1155C12.1155 14.8705 12.2017 14.6618 12.374 14.4895C12.5465 14.317 12.7552 14.2308 13 14.2308C13.2448 14.2308 13.4535 14.317 13.626 14.4895C13.7983 14.6618 13.8845 14.8705 13.8845 15.1155C13.8845 15.3603 13.7983 15.5689 13.626 15.7413C13.4535 15.9138 13.2448 16 13 16Z"
                    // fill="#19733B"
                  />
                </svg>
                <span className="font-montserrat laptop:text-2xl text-base ">
                  Calendar
                </span>
              </div>
              <CalendarEvent />
            </div>
            {/* upcoming events */}
            <UpcomingEvent />
          </div>
        </div>
      </div>
    </>
  );
}

export default NewsEvent;
